import { InputPadrao, InputDatePicker, InputTelefone, InputSummernote, InputDatePickerMultiplo, InputTimePicker, InputSwitch, InputNumero, TextArea } from '../../../../components/Inputs'
import { InputAtividadeEconomica, InputBeneficiario, InputBeneficiarioTitular, InputCooperadoPF, InputCooperadoPFPJ, InputEmpresaParceira, InputEstado, InputEstadoCivil, InputGrauDependencia, InputGrauInstrucao, InputMunicipio, InputOperadoraSaude, InputPais, InputPessoaJuridicaTipo, InputRaca, InputSexo, InputStatusAgenda } from '../../../../components/InputsAutoComplete'
import React, { useState, useEffect, useRef, useCallback } from 'react'
import Yup, { validaCNPJ, validaCPF, validaData, validaHora } from '../../../../util/Validacoes'
import { HeaderCadastro } from '../../../../components/Headers'
import { mostrarToast } from '../../../../components/Toasts'
import { Formik, Form } from 'formik'
import { BotaoPadrao } from '../../../../components/Botoes'
import { ajustarDadosTelefone, buscarCep, mensagens, useWindowSize } from '../../../../util/Utilitarios'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { salvar, get, consultar, visualizar, validar, acoesAgenda } from '../../../../util/AcessoApi'
import '../../../../assets/css/icones/iconsmind/style.css';
import Atalho from '../../../../util/Atalho'
import { ACOES, AGENDA_STATUS, MODULO } from '../../../../util/Enums'
import InputArquivoS3 from '../../../../components/InputArquivoS3'
import moment from 'moment'
import { downloadArquivoS3 } from '../../../../util/FuncoesComuns'
import { ModalCadastro, ModalDuasOpcoes, ModalPadraoCadastro } from '../../../../components/Modais'
import { getUsuario } from '../../../../util/Configuracoes'
import { LoadRelatorio } from '../../../../components/Loading'
import generateICS from '../../../../util/ICSGenerator.ts'

const ChamarPainel = (props) => {
    const [salvando, setSalvando] = useState(false)
    const [item, setItem] = useState({})
    const [carregando, setCarregando] = useState(true)
    const refAtualizacao = useRef(null)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [showModalValidacao, setShowModalValidacao] = useState(false)
    const [mensagemModal, setMensagemModal] = useState('')

    const [validacao, setValidacao] = useState({})

    const Submit = () => {
        setSalvando(true)
        let valuesAjustados = { ...valoresIniciais }

        salvar(
            valuesAjustados,
            '/atendimento/painel',
            () => {
                mostrarToast('sucesso', `Paciente ${valoresIniciais.paciente} foi enviado para o Painel de Atendimento!`)
                setSalvando(false)
                props.setShowModal(false)
                setValoresIniciais({})
                props.aposSubmit();
            },
            () => setSalvando(false),
            null
        )
    }

    const obterAgenda = () => {
        setCarregando(true)
        setValoresIniciais({
            agen_id: props.item.id,
            paciente: props.item.paciente,
            status: { value: AGENDA_STATUS.PAINEL },
            consultorio: props.item.consultorio
        })
        setCarregando(false)
    }

    useEffect(() => {
        if (props.item && props.item.id) {
            obterAgenda()
        }
    }, [props.item])

    return (
        <>
            <ModalDuasOpcoes
                showModal={props.showModal}
                setShowModal={props.setShowModal}
                funcaoOpcao2={() => {
                    Submit()
                }}
                funcaoOpcao1={() => props.setShowModal(false)}
                esconderFechar
                mensagem={
                    <>
                        Chamar <b>{valoresIniciais.paciente}</b> para <b>{valoresIniciais.consultorio}</b>?
                        <br />
                    </>
                }
                textoOpcao1={'Cancelar'}
                classeOpcao1={'btn-sm btn-primary-modal simples'}
                textoOpcao2={'Confirmar'}
            />
        </>
    )
}

export default ChamarPainel